export default __webpack_public_path__ + "locales/cs/InviteDialog.json?hash=e65843296909e32971f31bddfc87f40a";